import React, { useState, useEffect } from 'react';
import moment from 'moment';
import '../App.css';

const Clock = () => {
  const [date, setDate] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setDate(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const padZero = (num) => (num < 10 ? `0${num}` : num);

  const formattedTime = `${padZero(date.getHours())}:${padZero(
    date.getMinutes()
  )}:${padZero(date.getSeconds())}`;

  return <div className="date">{moment().format('YYYY年MM月DD日')} {formattedTime}</div>;
};

export default Clock;